import {useMutation, useQueryClient} from '@tanstack/react-query';

import {RQ_UPDATE_PROFILE_API} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

const withUrl = (config, key, value) => ({
  ...config,
  url: config.url.replace(`<%= ${key} %>`, value),
});

export const RQUpdateProfileAPI = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rq_update_profile'],

    mutationFn: async ({token, formData, id, role}) => {
      const config = withUrl(
        withUrl(RQ_UPDATE_PROFILE_API, 'role', role),
        'id',
        id,
      );
      return rqCreateRequest(config, formData, token, null);
    },

    onSuccess: (updatedProfile, {id}) => {
      // Invalidate the profile query so ProfileScreen refetches fresh data
      queryClient.invalidateQueries({
        queryKey: ['rq_employee_lookup_id', id],
      });
    },

    ...options,
  });
};
